// import { Notification } from 'element-ui'
import {login, bindLogin, loadUser, informationGetMosaicId} from '../service/login'
import { userStatus, userInfo, riskInfo } from '../service/user'
import {getLoadAllDictionary} from '../service/dictionary'
import {webTracingSetUserUuid} from "@/service/common";

const store = {
  state: {
    userId: null,
    username: null,
    customerName: null,
    customerEmail: null,
    customerIdNo: null,
    userInfos: {},
    loginStatus: '',
    title: '',
    phone: '',
    fundContent: [],
    questions: {
      group1: [],
      group2: []
    },
    riskEvaluation: {
      grades: null,
      level: null,
      need_level: null,
      effect_user: null,
      need_risk_again: null
    },
    cmps: [],
    homeTab: '',
    loadAllDictionary:[],
    isIdCardExpired: false,
    // 预约参数存储
    // 认申购预约单需要的参数
    applyParams: {},
    reservationData: {
      // 步骤条
      stepList: [],
      // 基金id
      fund_id: '',
      appoint_id: '',
      // 预约类型 0 认购；1 申购；2 追加；3 赎回
      apply_type: '',
      // 预约id
      apply_id: '',
      // 客户id
      client_id: '',
      // 1：电子合同 0：纸质合同
      electron_paper: '',
      // 1：需要CFCA 0：不需要
      cfca_state: '',
      /**
       * 1:签名设置密码签署承诺函+上传资质证明
       * 2:签名设置密码签署承诺函+双录+签署合同
       * 3:签名设置密码签署承诺函
       * 4:纸质双录
       */
      step_type: '',
      // 是否签名
      isSetSignature: false,
    },
  },
  getters: {
    getHomeTab(state) {
      return state.homeTab ? state.homeTab : JSON.parse(window.sessionStorage.getItem('homeTab'))
    }
  },
  mutations: {
    setApplyParams(state, data) {
      state.applyParams = data
    },
    setReservationData(state, data) {
      state.reservationData = {
        ...state.reservationData,
        ...data,
      }
    },
    // 清空
    clearReservationData(state) {
      state.reservationData = {}
    },
    setHomeTab(state, route) {
      state.homeTab = {path: route.path, query: route.query}
      window.sessionStorage.setItem('homeTab', JSON.stringify(state.homeTab))
    },
    setCmps(state, cmps) {
      state.cmps = cmps
    },
    setUnmatched (state, hasUnmatched) {
      state.hasUnmatched = hasUnmatched
    },
    setUser(state, {userId, username, customerName, customerEmail, userInfos, riskInfos,customerIdNo}) {
      state.userId = userId
      state.username = username
      state.customerName = customerName
      state.customerEmail = customerEmail
      state.userInfos = {...userInfos}
      state.riskEvaluation = {...riskInfos}
      state.customerIdNo = customerIdNo || ''
    },
    clearUser(state) {
      state.userId = null
      state.username = null
      state.customerName = null
      state.customerEmail = null
      state.customerIdNo = null
      state.userInfos = {}
      state.loginStatus = ''
    },
    answers(state, questions) { // 基金风险测试
      state.questions.group1 = [...questions.group1]
      state.questions.group2 = [...questions.group2]
      state.questions.questionnaire_id = questions.questionnaire_id
    },
    setLoginStatus(state, status) {
      state.loginStatus = status
    },
    updateNavTitle(state, title) {
      state.title = title
    },
    updateMobile(state,mobile){
      state.userInfos.mobile = mobile
    } ,
    updateUserInfo(state,userInfos){
      state.userInfos = {...userInfos}
    },
    setPhone (state, phone) {
      state.phone = phone
    },
    setLoadAllDictionary(state, loadAllDictionary) {
      state.loadAllDictionary = loadAllDictionary ? loadAllDictionary : []
      //console.log("本地同步数据 setLoadAllDictionary", state.loadAllDictionary)
    },
    setIdCardExpired(state, isExpired) {
      state.isIdCardExpired = isExpired
    },
  },
  actions: {
    async login ({ commit,dispatch }, { username, password }) {
      const { client_id: userId, username: uname, customer_name: customerName, customer_email: customerEmail } = await login(username, password)
      await dispatch('getLoadAllDictionary')
      commit('setUser', { userId, username: uname, customerName, customerEmail })
    },
    async bindLogin ({ commit,dispatch }, { username, password }) {
      const { client_id: userId, username: uname, customer_name: customerName, customer_email: customerEmail } = await bindLogin(username, password, true)
      await dispatch('getLoadAllDictionary')
      commit('setUser', { userId, username: uname, customerName, customerEmail })
    },
    async loadUser ({ commit }) {
      const { client_id: userId, username, customer_name: customerName, customer_email: customerEmail } = await loadUser()
      const userInfos = await userInfo()
      const riskInfos = await riskInfo()
      const {data:customerIdNo} = await informationGetMosaicId()
      commit('setUser', { userId, username, customerName, customerEmail, userInfos, riskInfos,customerIdNo })
      webTracingSetUserUuid(userId)
    },
    async userStatus ({ commit }) {
      const loginStatus = await userStatus()
      commit('setLoginStatus', loginStatus)
    },
    async getPhone ({ commit }, mobile) {
      commit('setPhone', mobile)
    },
    async getLoadAllDictionary({commit}) {
      let res = await getLoadAllDictionary()
      // console.log("本地缓存 异步请求枚举数据返回", res)
      commit('setLoadAllDictionary', res)
    }
  }
}

export default store
